import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import aboutimage from "../assets/Img/airaa-about-team.webp";
import Member from "../assets/Img/airaa-member-banner.webp";
import Achivement from "../assets/Img/airaa-achievements.webp";

const imageSections = [
  { src: Member, label: "experienceheader", footer: "experienceYears" },
  { src: aboutimage, label: "trustedBy", footer: "membersCount" },
  { src: Achivement, label: "caseSolved", footer: "caseSolvedCount" },
];
const statsData = [
  {
    value: 19,
    label: "Offices",
    gradient: "bg-gradient-to-r from-orange-400 to-orange-600",
  },
  {
    value: 14,
    label: "Years Of Excellence",
    gradient: "bg-gradient-to-r from-blue-400 to-blue-600",
  },

  {
    value: 1711,
    label: "Trusted Members",
    gradient: "bg-gradient-to-r from-green-400 to-green-600",
  },
  {
    value: 3331,
    label: "Cases / Issues Solved",
    gradient: "bg-gradient-to-r from-purple-400 to-purple-600",
  },
];

const AboutAiraComponent = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [countedValues, setCountedValues] = useState([0, 0, 0]);

  useEffect(() => {
    const timers = statsData.map((stat, index) => {
      let count = 0;
      const interval = setInterval(() => {
        count += Math.ceil(stat.value / 100); // Increase by a fraction of the total
        if (count >= stat.value) {
          count = stat.value;
          clearInterval(interval);
        }
        setCountedValues((prev) => {
          const newValues = [...prev];
          newValues[index] = count;
          return newValues;
        });
      }, 10); // Adjust speed here (lower is faster)

      return interval;
    });

    // Clear intervals on component unmount
    return () => timers.forEach(clearInterval);
  }, []);

  return (
    <section>
      <div className="flex flex-wrap gap-6 justify-center items-center">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center md:text-left"
        >
          <h2 className="text-4xl font-extrabold mb-4 text-blue-900 leading-tight">
            {t("aboutTitle")}{" "}
            <span className="text-green-600">{t("aboutTitle2")}</span>
          </h2>

          <p className="text-gray-700 text-lg mb-3 leading-relaxed text-justify">
            About AIRAA (All India Recruitment Agency Association) Founded in
            2011, AIRAA represents 1711+ recruitment agencies across India,
            working to enhance ethical, transparent, and sustainable employment
            opportunities for Indian workers globally.
          </p>
          <p className="text-gray-700 text-lg mb-3 leading-relaxed text-justify">
            We help by collaborating with the government and international
            stakeholders to shape policies that benefit recruitment agencies and
            job seekers. Our initiatives focus on skill development, industry
            promotion, and workforce mobility, ensuring Indian professionals
            stay competitive in global job markets.
          </p>
          <p className="text-gray-700 text-lg mb-3 leading-relaxed text-justify">
            AIRAA actively expands job opportunities, facilitates upskilling
            programs, and supports returning migrant workers by integrating
            global best practices into India's workforce. Through our "no
            conflicts" policy, we provide equal support to all members,
            fostering a strong and ethical recruitment industry.
          </p>
          <p className="text-gray-700 text-lg mb-3 leading-relaxed text-justify">
            By connecting overseas employers with skilled Indian talent, AIRAA
            strengthens global workforce mobility while advocating for fair
            employment practices and worker welfare.
          </p>
          <div className="flex justify-end items-end h-full">
            <button
              onClick={() => navigate("/about-airaa")}
              className="bg-green-600 text-white px-6 py-2 text-lg font-semibold rounded-lg shadow-md hover:bg-green-700 transition-all duration-300 transform hover:scale-105 hover:shadow-lg cursor-pointer"
            >
              {t("learnMore")}
            </button>
          </div>
        </motion.div>

        {/* The image section remains commented out, but can be uncommented if needed */}
        {/* {imageSections.map((img, index) => (
                    <motion.div key={index} initial={{ opacity: 0, x: 50 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }} className="relative flex flex-col items-center justify-center text-center group">
                        <div className="relative">
                            <img src={img.src} alt={t("aboutTitle")} className="rounded-xl shadow-lg w-[280px] h-[280px] object-cover border-4 border-white group-hover:shadow-green-400 transition-all duration-500" />
                            <div className="absolute top-2 left-2 bg-green-600 text-white text-xs font-semibold px-2 py-1 rounded-full shadow-md group-hover:scale-110 transition-all duration-300">{t(img.label)}</div>
                        </div>
                        <div className="mt-4 text-center">
                            <p className="text-xl text-blue-700 font-bold">{t(img.footer)}</p>
                        </div>
                    </motion.div>
                ))} */}

        {/* Stats Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 justify-center items-center w-full">
          {statsData.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.3 * index }}
              className="text-center p-6 rounded-xl shadow-lg relative overflow-hidden bg-white group h-[200px]"
            >
              <motion.div
                whileHover={{
                  scale: 1.1,
                  y: -20,
                }}
                className="relative flex justify-center items-center mt-6"
              >
                <motion.span
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.3 }}
                  className={`text-7xl font-bold text-transparent bg-clip-text ${stat.gradient}`}
                >
                  <motion.div
                    key={index}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.6 }}
                    className="text-5xl font-extrabold"
                  >
                    {countedValues[index]}+
                  </motion.div>
                </motion.span>
              </motion.div>
              <p className="text-xl text-blue-700 font-semibold mt-4">
                {stat.label}
              </p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default AboutAiraComponent;
